import { format } from "date-fns";

const formatDateWithTime = (date) => {
  const d = new Date(date);
  return format(d, "MM/dd/yyyy hh:mm a");
};

export default formatDateWithTime;
